module.exports = __webpack_public_path__ + "static/img/chanta (10).f151b52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (10).jpg
// module id = RkIL
// module chunks = 0